import { render, staticRenderFns } from "./Narration.vue?vue&type=template&id=88714d08&scoped=true"
import script from "./Narration.vue?vue&type=script&lang=js"
export * from "./Narration.vue?vue&type=script&lang=js"
import style0 from "./Narration.vue?vue&type=style&index=0&id=88714d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88714d08",
  null
  
)

export default component.exports